import React, { useState } from 'react';
import classNames from 'classnames';
import { IconButton } from '@agissc/ktag-map';
import Modal from './Modal';
import useAppState from '../../AppStore';

const Welcome = () => {
  return (
    <>
      <img
        alt="Willkommen"
        src="./assets/images/gfx_welcome.png"
        className="modal__image-full-width"
      />
      <h1>Willkommen in den neuen Online Karten!</h1>
      <h2>Was ist neu?</h2>
    </>
  );
};

const Layers = () => {
  return (
    <>
      <img
        alt=""
        src="./assets/images/gfx_layers.png"
        className="modal__image-full-width"
      />
      <h1>Mehrere Ebenen gleichzeitig ladbar</h1>
    </>
  );
};

const Search = () => {
  return (
    <>
      <img
        alt=""
        src="./assets/images/gfx_search.png"
        className="modal__image-full-width"
      />
      <h1>Eine Suche für alles: nach Orten und nach Ebenen</h1>
    </>
  );
};

const Download = () => {
  return (
    <>
      <img
        alt=""
        src="./assets/images/gfx_download.png"
        className="modal__image-full-width-smaller"
      />
      <h1>Direkter Zugang zum Download der Geodaten</h1>
    </>
  );
};

const MyMaps = () => {
  return (
    <>
      <img
        alt=""
        src="./assets/images/gfx_saved_maps.png"
        className="modal__image-full-width-smaller"
      />
      <h1>
        Speichern von individuell zusammengestellten Ebenen als &quot;meine Karten&quot;
      </h1>
    </>
  );
};

const End = () => {
  return (
    <>
      <img
        alt=""
        src="./assets/images/gfx_end.png"
        className="modal__image-full-width-smaller"
      />
      <h1>und vieles mehr...</h1>
      <p>
        <a
          href="https://www.ag.ch/de/verwaltung/dfr/geoportal/online-karten"
          target="_blank"
          rel="noreferrer"
        >
          Mehr Informationen zu den neuen Online Karten
        </a>
      </p>
      <h2>Wir wünschen viel Vergnügen!</h2>
    </>
  );
};

const StartupItems = [
  <Welcome />,
  <Layers />,
  <Search />,
  <Download />,
  <MyMaps />,
  <End />,
];

const StartUpModal = () => {
  const displayStartUpMessage = useAppState((state) => state.displayStartUpMessage);
  const toggleStartUpMessage = useAppState((state) => state.toggleStartUpMessage);

  const [itemIndex, setItemIndex] = useState(0);
  const [closeModal, setCloseModal] = useState(false);
  const [hideStartUpMessage, setHideStartUpMessage] = useState(false);

  const onModalClose = () => {
    if (hideStartUpMessage) {
      toggleStartUpMessage();
    }
  };

  if (!displayStartUpMessage) return null;

  const { length } = StartupItems;

  const scrollToIndex = (index: number) => {
    setItemIndex(index);
    const element = document.getElementById(`dot-${index}`);
    if (element) {
      element.scrollIntoView();
    }
  };

  const scrollPrevIndex = () => scrollToIndex(itemIndex - 1);
  const scrollNextIndex = () => scrollToIndex(itemIndex + 1);

  return (
    <Modal closed={closeModal} onClose={onModalClose}>
      <div className="carousel__container">
        {StartupItems.map((item, i) => (
          <div className="carousel__item" id={`dot-${i}`}>
            {item}
          </div>
        ))}
      </div>
      <div className="carousel__nav">
        <IconButton
          icon="arrow-left"
          onClick={scrollPrevIndex}
          additionalClassNames={classNames({
            'carousel__nav-previus-hide': itemIndex === 0,
          })}
        />
        <div>
          {Array.from({ length }, (_, i) => (
            <IconButton
              key={`dot-${i}`}
              icon="dot-outline"
              onClick={() => scrollToIndex(i)}
              additionalClassNames={classNames('carousel__nav-dot', {
                'carousel__nav-dot--active': i === itemIndex,
              })}
            />
          ))}
        </div>
        {itemIndex < length - 1 ? (
          <IconButton icon="internal" onClick={scrollNextIndex} />
        ) : (
          <IconButton icon="checkmark-circle" onClick={() => setCloseModal(true)} />
        )}
      </div>
      <div className="modal__footer">
        <input
          type="checkbox"
          onChange={() => setHideStartUpMessage((prev) => !prev)}
          className="form__input topic-sub-layer-list__item_checkbox"
        />{' '}
        Nicht mehr anzeigen
      </div>
    </Modal>
  );
};

export default StartUpModal;
